<div class="mat-tree-node">
  <div matRipple class="mc-tree-node-item" [style]="'--mc-flat-tree-node-level:' + this.node.level" (click)="onFolderClicked(node)">
    <!-- rail -->
    <div *ngFor="let i of (node.level | mcRange); let level = index" class="mc-tree-node-rail mc-border-divider" [style]="'--mc-flat-tree-rail-level:' + level"></div>

    <!-- selection or normal-->
    <div *ngIf="projectFilesTreeType !== 'selection' || disableFolderCheckboxes" class="mc-flex-grow-1">
      <ng-template [ngTemplateOutlet]="nodeTemplate"></ng-template>
    </div>

    <ng-container *ngIf="projectFilesTreeType === 'selection' && !disableFolderCheckboxes">
      <mat-checkbox [checked]="checked" [disabled]="disableSelectionTree" class="mc-tree-text-icon" color="accent-vivid" disableRipple="true" [indeterminate]="node.selected === TriSelectedState.Indeterminate" mcStopPropagation="click" (change)="onNodeCheckboxChanged(node)">
        <ng-template [ngTemplateOutlet]="nodeTemplate"></ng-template>
      </mat-checkbox>
      <span class="mc-fill-remaining-flex-space"></span>
    </ng-container>

    <!--Error and indicators -->
    <div class="mc-project-files-tree-folder-indicators mc-flex-shrink-0">
      <mat-icon *ngIf="node.error === true && !node.isLoading" class="mc-project-files-tree-folder-indicator mc-image-icon mc-image-icon-xxxxx-small mc-text-warn" fontSet="project-titan" fontIcon="icon-alert" matTooltip="Unable to load the files. Click to try again."></mat-icon>

      <ng-container *ngIf="indicators && !node.isLoading && !node.error">
        <ng-container *ngFor="let indicator of indicators">
          <span *ngIf="indicator.name === 'dot'" class="mc-project-files-tree-folder-indicator mc-dot mc-dot-small" [ngClass]="indicator.color"></span>
        </ng-container>
      </ng-container>
    </div>

    <mat-progress-bar *ngIf="node.isLoading === true" class="mc-project-files-tree-folder-progress" mode="indeterminate" color="accent-vivid"></mat-progress-bar>
  </div>
</div>

<ng-template #nodeTemplate>
  <ng-container *ngIf="treeItemDirective; else defaultNode" [ngTemplateOutlet]="treeItemDirective.templateRef" [ngTemplateOutletContext]="{ $implicit: node, expanded: isFolderExpanded }"></ng-container>
  <ng-template #defaultNode>
    <mat-icon class="mc-tree-text-icon" color="accent-vivid" fontSet="project-titan" [fontIcon]="isFolderExpanded ? 'icon-down-arrow-90' : 'icon-right-arrow-90'" mcPreventDefault="click" mcStopPropagation="click" (click)="onFolderClicked(node)"></mat-icon>{{node.name}}
  </ng-template>
</ng-template>